import type {RawProductData} from './splitProductsFromMessage'
import type {RawQuestionData} from './splitQuestionFromMessage'

export default function mergeTextAndDataNode(value: (string | RawProductData | RawQuestionData)[]) {
  return value.reduce<(string | RawProductData | RawQuestionData)[]>((acc, val) => {
    const lastItem = acc[acc.length - 1]
    const thisItem = val

    if (typeof thisItem === 'string' && typeof lastItem === 'string') {
      acc[acc.length - 1] = lastItem.concat(thisItem)
      return acc
    }

    if (typeof thisItem === 'object' && typeof lastItem === 'object') {
      if (Array.isArray(lastItem.data) && Array.isArray(thisItem.data))
        lastItem.data.push(...thisItem.data)
      else acc.push(thisItem)
      return acc
    }

    if (thisItem) {
      acc.push(thisItem)
    }

    return acc
  }, [])
}
